import {clientTab, setSession, getSession} from '../../tools/config'
let clientTabInfo = {
    state: {
        info: {
        }
    },
    mutations: {
        setClient (state, info) {
            setSession(clientTab, info)
            state.info = info
        },
        resetClient(state) {
            setSession(clientTab, {})
            state.user = {}
        }
    },
    getters: {
        getClient (state) {
            if (state.info) {
                state.info = getSession(clientTab)
            }
            return state.info
        }
    }
}

export default clientTabInfo


// WEBPACK FOOTER //
// ./src/store/modules/clientTab.js